// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"46721831","386":"31d4f400","453":"529b5e4d","806":"30c65adc"}[chunkId] + ".chunk.js";
};